import React from 'react';
import { Button, Dialog, Image, T } from '@colonist/ui';
import IconGoogle from '@static/images/icon_google_color.svg';
import IconDiscord from '@static/images/icon_discord_color.svg';
import IconApple from '@static/images/icon_apple.svg';
import styles from './EndgameSignupDialog.module.scss';
/** Guest signup prompt after milestone completed games. */ export const EndgameSignupDialog = ({ open, onClose, playedGameCount, onGoogleLogin, onDiscordLogin, onAppleLogin, onContinueAsGuest })=>{
    const handleContinueAsGuest = ()=>{
        onContinueAsGuest();
        onClose();
    };
    const providerButtons = [
        {
            context: 'google',
            icon: IconGoogle,
            onClick: onGoogleLogin
        },
        {
            context: 'discord',
            icon: IconDiscord,
            onClick: onDiscordLogin
        },
        {
            context: 'apple',
            icon: IconApple,
            onClick: onAppleLogin
        }
    ];
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        size: "sm"
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.endGame.signupPopup.title'
        }
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.body
    }, /*#__PURE__*/ React.createElement("p", {
        className: styles.description
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:game.endGame.signupPopup.description',
            options: {
                playedGameCount: playedGameCount
            }
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: styles.buttons
    }, providerButtons.map((provider)=>{
        const label = {
            key: 'strings:popups.login.continueWith',
            options: {
                context: provider.context
            }
        };
        return /*#__PURE__*/ React.createElement(Button, {
            key: provider.context,
            variant: "secondary",
            size: "md",
            onClick: provider.onClick
        }, /*#__PURE__*/ React.createElement("span", {
            className: styles.providerLabel
        }, /*#__PURE__*/ React.createElement(Image, {
            className: styles.providerIcon,
            image: {
                src: provider.icon,
                alt: label
            }
        }), /*#__PURE__*/ React.createElement("p", {
            className: styles.providerText
        }, /*#__PURE__*/ React.createElement(T, {
            id: label
        }))));
    }), /*#__PURE__*/ React.createElement(Button, {
        variant: "ghost",
        size: "md",
        onClick: handleContinueAsGuest
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.login.continueAsGuest'
        }
    }))))));
};
